import ShareableLinkDesktopNavigation from './ShareableLinkDesktopNavigation.component';

export default ShareableLinkDesktopNavigation;
